
  import { hasSsoEnabled } from '@/ui/auth/auth';
  import { Container } from '@/ui/components/Container';
  import SsoForbidden from '@/ui/pages/sso/SsoForbidden.vue';
  import { defineComponent } from 'vue';
  import { SsoConfigurationForm } from '@/ui/pages/sso/SsoConfigurationForm';

  export default defineComponent({
    components: {
      SsoForbidden,
      Container,
      SsoConfigurationForm,
    },
    setup() {
      return {
        hasSsoEnabled,
      };
    },
  });
